import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putInventory } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.PUT,
  api: putInventory,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/inventories/PutAction.js